export default __webpack_public_path__ + "static/char-v-47-zh-Hant-31f988649c9fe1387dd58f64e6c3b2b6.mp4";